module.exports = __webpack_public_path__ + "static/media/hiError.a96088a2.gif";